module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0128.jpg?v=dfe9a8d2";